import { fetchGenreMarketProfiles } from '@intelligence/v3/services/genreMarketProfile';
import { LINE_CHART_ORDER_BY } from '@intelligence/v3/utils/common';
import { PAGINATION_FETCH_PARAMS } from '@intelligence/v3/constants';

/**
 * 合并接口返回的list列表、newzoo_list列表为一个list，因为前端要分页、排序
 * @param data 接口返回数据
 */
const mergeGenreMarketProfileList = (data?: IGenreMarketProfileResponseData): IPaginationData<IGenreMarketProfile> => {
  const list = data?.list;
  const newzooList = data?.newzoo_list;

  // 抓出list的所有markets
  const listMarkets = list?.map((item) => item?.market) || [];
  // 抓出newzooList的所有markets
  const newzooListMarkets = newzooList?.map((item) => item?.market) || [];
  // 合并list、newzooList的markets，并且去重，组装全量的markets
  const marketsSet = new Set<string>([...listMarkets, ...newzooListMarkets]);

  // 遍历全量的markets，生成market下的指标对象
  const listNew = Array.from(marketsSet).map<IGenreMarketProfile>((market) => {
    const commonMetricsData = list?.find((item) => market === item?.market);
    const newzooMetricsData = newzooList?.find((item) => market === item?.market);
    return { date: '', region: '', market: '', rank: Number.NaN, ...commonMetricsData, ...newzooMetricsData };
  });

  return { total: listNew.length, list: listNew };
};

/**
 * 获取Genre Profile、Market Profile页面列表数据
 * @param params 参数对象
 */
export const fetchGenreMarketProfileList = async (
  params: Omit<IGenreMarketProfileFetchParams, 'group_by' | 'page' | 'page_size'>,
) => {
  const paramsData: any = {
    ...PAGINATION_FETCH_PARAMS,
    ...params,
    filter: {
      ...params?.filter,
      game_count: true,
    },
    group_by: ['market'],
  };
  const res = await fetchGenreMarketProfiles(paramsData);
  const resData = res?.data;
  const req = res?.req;

  paramsData.start_date = req?.start_date || '';
  paramsData.end_date = req?.end_date || '';

  return { ...res, data: mergeGenreMarketProfileList(resData), paramsData };
};

/**
 * 获取Genre Profile、Market Profile页面折线图列表数据
 * @param params 参数对象
 */
export const fetchGenreMarketProfileLineChartList = (
  params: Omit<IGenreMarketProfileFetchParams, 'group_by' | 'order_by' | 'page' | 'page_size'>,
) => {
  return fetchGenreMarketProfiles({
    ...params,
    ...PAGINATION_FETCH_PARAMS,
    group_by: ['date', 'market'],
    order_by: LINE_CHART_ORDER_BY,
  });
};
